import Icon from '../components/Icon.vue'

Icon.register({
  expand: {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M0 180v-124c0-13.3 10.7-24 24-24h124c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-84v84c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12zM288 44c0-6.6 5.4-12 12-12h124c13.3 0 24 10.7 24 24v124c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-84h-84c-6.6 0-12-5.4-12-12v-40zM436 320c6.6 0 12 5.4 12 12v124c0 13.3-10.7 24-24 24h-124c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h84v-84c0-6.6 5.4-12 12-12h40zM160 468c0 6.6-5.4 12-12 12h-124c-13.3 0-24-10.7-24-24v-124c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v84h84c6.6 0 12 5.4 12 12v40z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/expand.js
// module id = 1313
// module chunks = 0